<template>
  <!--
    作者：luoyiming
    时间：2020-06-04
    描述：插件中心-积分商城-商品设置-添加商品-商品信息
  -->
  <div>
    <div class="common-form">批次数据</div>
      <el-form-item label="批次名称" prop="title" :rules="[{ required: true, message: '请填写批次名称' }]">
        <el-input type="text" v-model="form.title" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="生码规则">
        <el-radio-group v-model="form.rule">
          <el-radio-button label="birthday">生日</el-radio-button>
          <el-radio-button label="sort">排序</el-radio-button>
          <el-radio-button label="randomly">随机</el-radio-button>
        </el-radio-group>
    </el-form-item>
    <el-form-item v-if="form.rule === 'birthday'" label="开启批量生成" prop="is_batch"><el-switch v-model="form.is_batch"></el-switch></el-form-item>

    <el-form-item v-if="form.rule === 'birthday' && !form.is_batch" label="生成时间">
        <el-date-picker
          v-model="form.add_time"
          align="right"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd" 
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions">
        </el-date-picker>
        <div class="ml10 gray">生成时间</div>
    </el-form-item>
    <el-form-item v-if="form.rule === 'birthday' && form.is_batch"  label="生成时间">
         <el-date-picker
          v-model="form.add_time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          format="yyyy-MM-dd" 
          value-format="yyyy-MM-dd"
          >
        </el-date-picker>
        <div class="ml10 gray">生成的开始日期与截止日期</div>
    </el-form-item>
    <el-form-item v-if="form.rule != 'birthday'"  label="码前缀" prop="prefix" :rules="[{ required: false, message: '请填写码前缀' }]">
        <el-input type="text" v-model="form.prefix" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="码起始数" prop="rule_start" :rules="[{ required: true, message: '请输入值' }]"><el-input type="number" v-model="form.rule_start" class="max-w460"></el-input></el-form-item>
    <el-form-item label="码起始数" prop="rule_end" :rules="[{ required: true, message: '请输入值' }]"><el-input type="number" v-model="form.rule_end" class="max-w460"></el-input></el-form-item>
    <el-form-item label="编码是否补零">
        <el-radio-group v-model="form.is_zeroize">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
    </el-form-item>
    <el-form-item v-if="form.is_zeroize === 1" label="零数量" prop="zero_number" :rules="[{ required: true, message: '请输入值' }]"><el-input type="number" v-model="form.zero_number" class="max-w460"></el-input></el-form-item>
  </div>
</template>

<script>
export default {
  data() {
    return {
      /*如果没有后面的-8.64e7就是不可以选择今天的*/
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      }
    };
  },
  inject: ['form'],
  created() {
    
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/codebatch/part/Basic.vue